<template>
  <div>
    <div class="b-contract__payment-panel py-5">
      <div class="col-12 b-form__container_type_flex">
        <div class="col-11">
          <CreateOrChooseAssetSmallWidget :availableAssetIds="availableAssetIdsForGroupIncludingSelected"
                                          :currentAssetId="assetId" @selectedAssetId="setAssetId($event)"
                                          @createAssetId="onCreateAssetId"/>
        </div>
        <div class="col-1" v-if="assetsCount > 1">
          <div class="b-contract__payment-panel-btn">
            <button type="button" class="b-btn b-btn_border_none" @click="deleteAsset">
              <dynamic-icon class="b-btn__icon b-btn__icon_color_main-text" icon="delete"></dynamic-icon>
            </button>
          </div>
        </div>
      </div>
      <div class="col-12 mt-5 b-form__row_type_flex b-form__row_type_flex-end">
        <div class="col-5 b-form__container_type_flex">
          <checkbox class="b-checkbox" :id="`isSeveralAssetComponents${assetIndex}-${assetId}`" v-model="isSeveralAssetComponents">{{$t('CONTENT.assets.is_asset_components')}}</checkbox>
          <dynamic-icon class="ml-1" v-tooltip="$t('CONTENT.assets.is_asset_components_hint')" icon="question"></dynamic-icon>
        </div>
      </div>
    </div>
    <div class="b-contract__section-inner px-6">
      <div v-for="(assetComponentForAsset, assetComponentForAssetIndex) in assetComponentByAssetId">
        <AssetComponentWidget :assetComponent="assetComponentForAsset"
                              :assetComponentsLength="assetComponentByAssetId.length"
                              :assetComponentIndex="assetComponentForAssetIndex"
                              :isSeveralAssetComponents="isSeveralAssetComponents"
                              :unitsOfMeasure="unitsOfMeasure"
                              :assetId="assetId"
                              :currencyCodes="currencyCodes"
                              :validationErrors="validationErrors[assetComponentForAsset.validationIndex]"
                              @changeAssetComponentData="onChangeAssetComponentData"
                              @deleteAssetComponent="onDeleteAssetComponent($event)"
        ></AssetComponentWidget>
      </div>
      <div class="row" v-if="isSeveralAssetComponents">
          <div class="col-3 my-6">
            <button type="button" class="b-btn" @click="createAssetComponent" data-cy="add-asset-component">
              <dynamic-icon class="b-btn__icon b-btn__icon_color_main-text" icon="plus"></dynamic-icon>
              {{$t('CONTENT.assets.add_component')}}
            </button>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import AssetComponent from "../../../../../plugins/assetComponent/models/AssetComponent";
import CreateOrChooseAssetSmallWidget from "../../../../widgets/CreateOrChooseAssetSmallWidget";

export default {
  components: {
    CreateOrChooseAssetSmallWidget,
  },
  props: {
    assetComponentByAssetId: {
      type: Array,
      required: true
    },
    updatedCurrentAssetId: {
      type: Number,
    },
    assetIndex: {
      type: Number
    },
    availableAssetIdsForGroup: {
      type: Array
    },
    assetsCount: {
      type: Number,
    },
    validationErrors: {
      type: Array
    }
  },
  data() {
    return {
      isSeveralAssetComponents: false,
      assetId: null
    };
  },
  created() {
    this.assetId = this.assetComponentByAssetId[0].assetId;
    if(this.assetComponentByAssetId.length > 1) {
      this.isSeveralAssetComponents = true;
    }
  },
  computed: {
		...mapGetters(['getUnderlyingAssetTypes']),
    ...mapGetters(["getUnitOfMeasure"]),
    ...mapGetters(["getCurrencyCode"]),
    ...mapGetters(["getAssets"]),
    ...mapGetters("assetComponentsPlugin", ['getAllAssetComponents']),
    availableAssetIdsForGroupIncludingSelected() {
		  let availableClone = [...this.availableAssetIdsForGroup];
		  let choosenAsset = this.getAssets.find(a => a.idInDB === this.assetId);
      availableClone.push(choosenAsset);
		  return availableClone;
    },
    currencyCodes() {
      return this.getCurrencyCode;
    },
    unitsOfMeasure() {
      return this.getUnitOfMeasure;
    },
  },
	watch: {
    assetComponentByAssetId(assetComponentsArray) {
      this.assetId = assetComponentsArray[0].assetId;
    },
		async isSeveralAssetComponents() {
			if(this.isSeveralAssetComponents === false && this.assetComponentByAssetId.length > 1) {
				await this.$store.commit('assetComponentsPlugin/removeAssetComponents', this.assetId);
			}
		},
	},
  methods: {
    async createAssetComponent() {
      let newAssetComponent = AssetComponent.createNew();
      newAssetComponent.assetId = this.assetId;
      this.$store.commit('assetComponentsPlugin/setNewAssetComponent', newAssetComponent);
    },
    setAssetId(assetIdInfoObject) {
      if(assetIdInfoObject.oldAssetId !== null) {
        this.$emit('newAssetSelected', { old: assetIdInfoObject.oldAssetId, new: assetIdInfoObject.currentAssetId});
      }

      if (this.assetId !== assetIdInfoObject.id) {
        this.$store.commit('assetComponentsPlugin/updateAssetIdForAssetComponents', {
          newAssetId: assetIdInfoObject.currentAssetId,
          assetComponentsForCurrentAsset: this.assetComponentByAssetId
        });
      }
    },
    deleteAsset() {
      let removedAssetComponentsArray = [];
      for (let i = 0; i < this.getAllAssetComponents.length; i++) {
        if(this.getAllAssetComponents[i].assetId === this.assetId) {
          removedAssetComponentsArray.push(this.getAllAssetComponents[i].validationIndex);
        }
      }

      this.$eventBus.$emit('deleteAsset', removedAssetComponentsArray);

      this.$store.commit("assetComponentsPlugin/deleteAsset", {
        assetId: this.assetId,
      });
      this.$emit('deleteAsset', this.assetId);
    },
    onDeleteAssetComponent(assetComponent) {
      this.$store.commit("assetComponentsPlugin/deleteAssetComponent", {
        assetComponent: assetComponent,
      });
      for (let i = 0; i < this.assetComponentByAssetId.length; i++) {
        if(this.assetComponentByAssetId[i] === assetComponent) {
          this.assetComponentByAssetId.splice(i, 1);
        }
      }
      if(this.assetComponentByAssetId.length <= 1) {
        this.isSeveralAssetComponents = false;
      }
    },
    onChangeAssetComponentData() {
      this.$store.commit('SET_VIEW_STATE_OF_CHARTS', true);
    },
    onCreateAssetId(assetInfoObj) {
      this.$store.commit('assetComponentsPlugin/updateAssetIdForAssetComponents', {
        newAssetId: assetInfoObj.newAssetId,
        assetComponentsForCurrentAsset: this.assetComponentByAssetId
      });

      this.$emit('newAssetCreated', { old: assetInfoObj.oldAssetId, new: assetInfoObj.newAssetId});
    }
  }
};
</script>
